if (!window.Eurus.loadedScript.has('image-alt-fallback.js')) {
  window.Eurus.loadedScript.add('image-alt-fallback.js');

  (() => {
    const normalize = (value) => (value || '').replace(/\s+/g, ' ').trim();

    const pageTitle = () => {
      const heading = document.querySelector('h1');
      const title = normalize(heading?.textContent) || normalize(document.title).replace(/\s*[|-]\s*.*$/, '');
      return title || 'Glam and Gems';
    };

    const nearbyHeading = (image) => {
      const container = image.closest('section, article, li, .card-product, .bundler-product, .product-info, .shopify-section');
      const heading = container?.querySelector('h1, h2, h3, .h1, .h2, .h3, [data-product-title], .product-title');
      return normalize(heading?.textContent || heading?.getAttribute('data-product-title'));
    };

    const sourceName = (image) => {
      const source = image.currentSrc || image.src || image.getAttribute('srcset') || '';
      const file = source.split(/[?#]/)[0].split('/').pop() || '';
      return normalize(decodeURIComponent(file).replace(/\.[a-z0-9]+$/i, '').replace(/[-_]+/g, ' '));
    };

    const fallbackAlt = (image) => (
      normalize(image.getAttribute('data-alt')) ||
      normalize(image.getAttribute('title')) ||
      normalize(image.closest('[aria-label]')?.getAttribute('aria-label')) ||
      nearbyHeading(image) ||
      pageTitle() ||
      sourceName(image)
    );

    const applyAlt = (root = document) => {
      root.querySelectorAll?.('img').forEach((image) => {
        if (!normalize(image.getAttribute('alt'))) {
          image.setAttribute('alt', fallbackAlt(image));
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => applyAlt(), { once: true });
    } else {
      applyAlt();
    }

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== Node.ELEMENT_NODE) return;
          if (node.matches?.('img')) {
            if (!normalize(node.getAttribute('alt'))) node.setAttribute('alt', fallbackAlt(node));
            return;
          }
          applyAlt(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  })();
}